import styled from "styled-components";
import HStack from "shared/components/layout/stack/HStack";

export const Container = styled.div`
    display: table-cell;
    vertical-align: middle;
    padding: 0 0.5rem;
    height: 40px;
`;

export const Name = styled.label`
    margin: 0;
    font-size: 11px;
    font-family: ${globalThis.config.fonts.families.regular};
    color: ${globalThis.config.colors.gray2};
    font-weight: 400;
    ${(props) =>
        props.link &&
        `
        cursor: pointer;
    `}

    ${(props) =>
        (props.SOWValue >= 60 ||
            props.SOWValue === 0 ||
            props.SOWValue === null ||
            props.projectName === "Placeholder Job" ||
            props.SOWTitle === "N/A" ||
            props.SOWTitle === "None") &&
        `
            color: ${globalThis.config.colors.black};
    `}
`;

export const StyledProjectRow = styled(HStack)`
    gap: 8px;
    ${(props) =>
        (props.SOWValue >= 60 ||
            props.SOWValue === 0 ||
            props.SOWValue === null ||
            props.projectName === "Placeholder Job" ||
            props.SOWTitle === "N/A" ||
            props.SOWTitle === "None") &&
        `
             gap:0;
    `}
`;
